import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Button, Rate, Modal } from "antd";
import { LoadingOutlined, StarFilled, StarOutlined } from "@ant-design/icons";
import suitCaseIcon from "../../../../../../assets/img/ps_suitcase.svg";

import "./ReceivedBidsCard.css";
import history from "../../../../../../routes/history";
import moment from "moment";
import PlaceBidModal from "../../../../../../components/PlaceBidModal/PlaceBidModal";
import {
  retractBid,
  updateBid,
  updateProposal,

  // addMessageFavorites,
  // removeMessageFavorites,
  addMessageToFavourite,
  removeMessageFromFavourite,
} from "../../../../../../redux/actions";

import { useSelector, useDispatch } from "react-redux";
import { RiCheckDoubleLine } from "react-icons/ri";
import { HyperlinkParagraph } from "../../../../../../components/HyperlinkPara";
import TextArea from "antd/lib/input/TextArea";
import { DefaultRating } from "../../../../../../assets/helpers";
import InfoIcon from "../../../../../../assets/icons/InfoIcon.svg";
import InfoIconLight from "../../../../../../assets/icons/InfoIconLight.svg";
import RedirectIcon from "../../../../../../assets/icons/RedirectIcon.svg";
import ExperienceIcon from "../../../../../../assets/icons/ExperienceIcon.svg";
import CalenderIcon from "../../../../../../assets/icons/CalenderIcon.svg";
import DurationIcon from "../../../../../../assets/icons/DurationIcon.svg";
import AuthorizationIcon from "../../../../../../assets/icons/AuthorizationIcon.svg";
import WorkPlaceIcon from "../../../../../../assets/icons/WorkPlaceIcon.svg";
import Speciality from "../../../../../../assets/img/Speciality.svg";
import Discipline from "../../../../../../assets/img/Discipline.svg";
import shift from "../../../../../../assets/img/shift.svg";
import StarIcon from "../../../../../../assets/icons/StarIcon.svg";
import ShowMoreIcon from "../../../../../../assets/icons/ShowMoreIcon.svg";
import { Tooltip } from 'react-tooltip';
import PayCalculation from "./payCalculation";
import { BsFillCaretLeftSquareFill } from "react-icons/bs";

const budgetOptions = [
  {
    BudgetTypeId: 3,
    BudgetTypeName: "Month",
    BudgetType: "mn",
  },
  {
    BudgetTypeId: 1,
    BudgetTypeName: "Hour",
    BudgetType: "hr",
  },
  {
    BudgetTypeId: 5,
    BudgetTypeName: "Daily",
    BudgetType: "daily",
  },
  {
    BudgetTypeId: 2,
    BudgetTypeName: "Week",
    BudgetType: "wk",
  },

  {
    BudgetTypeId: 4,
    BudgetTypeName: "Year",
    BudgetType: "yr",
  },
];
const contractOptions = [
  {
    IdealContractLengthId: 1,
    IdealContractLengthName: "1 month",
    IdealContractLengthValue: 1,
  },
  {
    IdealContractLengthId: 2,
    IdealContractLengthName: "2 months",
    IdealContractLengthValue: 2,
  },
  {
    IdealContractLengthId: 3,
    IdealContractLengthName: "3 months",
    IdealContractLengthValue: 3,
  },
  {
    IdealContractLengthId: 4,
    IdealContractLengthName: "4 months",
    IdealContractLengthValue: 4,
  },
  {
    IdealContractLengthId: 5,
    IdealContractLengthName: "5 months",
    IdealContractLengthValue: 5,
  },
  {
    IdealContractLengthId: 6,
    IdealContractLengthName: "6 months",
    IdealContractLengthValue: 6,
  },
  {
    IdealContractLengthId: 7,
    IdealContractLengthName: "7 months",
    IdealContractLengthValue: 7,
  },
  {
    IdealContractLengthId: 8,
    IdealContractLengthName: "8 months",
    IdealContractLengthValue: 8,
  },
  {
    IdealContractLengthId: 9,
    IdealContractLengthName: "9 months",
    IdealContractLengthValue: 9,
  },
  {
    IdealContractLengthId: 10,
    IdealContractLengthName: "10 months",
    IdealContractLengthValue: 10,
  },
  {
    IdealContractLengthId: 11,
    IdealContractLengthName: "11 months",
    IdealContractLengthValue: 11,
  },
  {
    IdealContractLengthId: 12,
    IdealContractLengthName: "1 year",
    IdealContractLengthValue: 12,
  },
  {
    IdealContractLengthId: 13,
    IdealContractLengthName: "1+ years",
    IdealContractLengthValue: 13,
  },
  {
    IdealContractLengthId: 14,
    IdealContractLengthName: "Negotiable",
    IdealContractLengthValue: 14,
  },
  {
    IdealContractLengthId: 15,
    IdealContractLengthName: "13 weeks",
    IdealContractLengthValue: 15,
  },
  {
    IdealContractLengthId: 16,
    IdealContractLengthName: "1 Week",
    IdealContractLengthValue: 16,
  },
  {
    IdealContractLengthId: 17,
    IdealContractLengthName: "6 weeks",
    IdealContractLengthValue: 17,
  },
  {
    IdealContractLengthId: 18,
    IdealContractLengthName: "12 weeks",
    IdealContractLengthValue: 18,
  },
];

export default function ReceivedBidsCard({
  name,
  img,
  cardDetails,
  status,
  SkillListingCard,
  GigCard,
  source,
  Created,
  data,
  setRetractedBy,
  records,
  SourceName,
  SourceId,
  setfavCard,
  Index,
  nonNullIndex

}) {
  const dispatch = useDispatch();
  const professionCode = JSON.parse(localStorage.getItem("userProfile"));
  const [profilePic, setProfilePic] = useState();
  const [placebidModal, setplacebidModal] = useState();
  const [rejectModalVisible, setRejectModalVisible] = useState(false);
  const [rejectReason, setRejectReason] = useState(false);
  const [otherReason, setOtherReason] = useState('');
  const [declineReason, setDeclineReason] = useState('');
  const [disableReasonCheck, setDisableReasonCheck] = useState(true);
  const [submitReasonClicked, setSubmitReasonClicked] = useState(false);
  const [candidateList, setCandidateList] = useState();
  const inputA = useRef(null);
  const inputN = useRef(null);
  const inputAs = useRef(null);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [favClicked, setFacClicked] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [retracted, setRetracted] = useState(false);
  const [disable, setDisable] = useState(true);
  const [fav, setFav] = useState(false);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [HidePagePvt, setHidePagePvt] = useState(false);
  const tooltipRef = useRef(null);

  const budgetType = cardDetails?.BudgetTypeId
    ? budgetOptions?.find((o) => {
      return o.BudgetTypeId === cardDetails?.BudgetTypeId;
    }).BudgetType
    : null

  const inbox = useSelector((state) => state.messagesReducer.inbox);
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const favouriteRed = useSelector((state) => state?.conversationFavReducer);

  const RetractLoading = useSelector(
    (state) => state.retractBidReducers.loading
  );
  const RetractSuccess = useSelector(
    (state) => state.retractBidReducers.success
  );
  const bidUpdateSuccess = useSelector(
    (state) => state.updateBidReducers.success
  );
  const proposalLoading = useSelector(
    (state) => state.updateProposalReducers.loading
  );
  const jobDetails = useSelector((state) => state.messagesReducer.jobDetail);

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  const jobordertype = data?.GigCard?.JobOrderTypes?.JobOrderTypeName;
  const bidStatus = useSelector((state) => state.messagesReducer.bidStatus);
  if (/\s/g.test(img)) {
    img.then((value) => setProfilePic(value));
  }

  const notification = useSelector(
    (state) => state.fetchNotificationReducer.notification
  );

  const privateids = notification[0]?.senderprofile[0]?.EmployeeAssociation

  const handleInfoIconClick = () => {
    setIsTooltipVisible(true);
    setIsHovered(true);
  };

  const handleInfoIconHover = () => {
    setIsHovered(true);
  };

  const handleInfoIconMouseLeave = () => {
    setIsHovered(false);
  };

  const handleTooltipClose = () => {
    setIsTooltipVisible(false);
    setIsHovered(false);
  }

  useEffect(() => {
    // console.log('favRed index fav =>',inbox?.data?.data?.body?.conversations[Index]?.IsFavorite)
    setFav(inbox?.data?.data?.body?.conversations[Index]?.IsFavorite)
  }, [inbox?.data?.data?.body?.conversations[Index]?.IsFavorite])

  const EditBidFunction = (value) => {
    setplacebidModal(value);
    setEditModal(true);
    // history.push({
    //   pathname: '/editBidPage',
    //   state: { placebidModal: placebidModal, candidateList: candidateList, bidUpdateSuccess: bidUpdateSuccess, cardDetails: cardDetails, SkillListingCard: SkillListingCard, professionCode: professionCode }
    // })
  };

  useEffect(() => {
    if (otherReason?.length > 0) {
      inputA.current.value = null;
      inputN.current.value = null;
      inputAs.current.value = null;
      inputA.current.style.backgroundColor = "white";
      inputN.current.style.backgroundColor = "white";
      inputAs.current.style.backgroundColor = "white";
    }
  }, [otherReason])

  useEffect(() => {
    setLoading(favouriteRed?.loading);
    if (!favouriteRed?.loading) {
      setFacClicked(false)
    }
  }, [favouriteRed?.loading]);

  // console.log('favouriteRed?.loading>>>>>', loading, favouriteRed?.loading)
  // useEffect(() => {
  //   setFav(records?.IsFavorite);
  //   console.log("records?.IsFavorite", records?.IsFavorite);
  // }, [records?.IsFavorite]);


  useEffect(() => {
    // id: Pdetails?.skill_listings?._id,
    //       img: Pdetails?.user_Schema?.profile.PictureUrl,
    //       name: Pdetails.user_Schema ? Pdetails.user_Schema.name : "",
    //       experience: Pdetails.experience ? Pdetails.experience : "0-0",
    //       title: Pdetails?.skill_listings?.Title,
    //       desired_rate: Pdetails?.skill_listings?.MinimumBid,
    //       bidType: Pdetails?.skill_listings?.MinimumBidType,
    setCandidateList([
      {
        name: data?.RecipientUser?.Profiles?.FirstName
          ? data?.RecipientUser?.Profiles?.FirstName +
          " " +
          data?.RecipientUser?.Profiles?.LastName
          : data?.RecipientUser?.UserName,
        AccountId: data?.RecipientUser?.AccountId,
        email: data?.RecipientUser?.EmailAddress,
        MobilePhone: data?.RecipientUser?.Profiles?.MobilePhone,
        bidType: SkillListingCard?.BudgetTypes?.BudgetTypeName,
        // desired_rate: cardDetails?.Rate ?? cardDetails?.Rate?.$numberDecimal ?? bidUpdateSuccess?.Rate ?? bidUpdateSuccess?.Rate?.$numberDecimal,
        desired_rate: professionCode?.Professions?.ProfessionCode !== "IT" ?
          Math.floor(SkillListingCard?.MinimumBid?.$numberDecimal)
            ? Math.floor(SkillListingCard?.MinimumBid?.$numberDecimal)
            : Math.floor(SkillListingCard?.MinimumBid) :
          SkillListingCard?.ClientRate?.$numberDecimal
            ? parseFloat(SkillListingCard?.ClientRate?.$numberDecimal)
            : SkillListingCard?.ClientRate,
        experience:
          data?.RecipientUser?.Profiles?.ExperienceLevels
            ?.ExperienceLevelName ?? "N/A",
        title: SkillListingCard?.Title,
        img: data?.RecipientUser?.Profiles?.PictureUrl,
        id: SkillListingCard?._id,
        lastActive: data?.RecipientUser?.LastSuccessfulLoginDate
          ? moment(data?.RecipientUser?.LastSuccessfulLoginDate).fromNow()
          : "N/A",
        ConversationId: data?.ConversationId,
      },
    ]);
  }, [data, profilePic]);

  // const showModal = () => {
  //   setVisible(true);
  // };
  useEffect(() => {
    if (otherReason?.length > 0 || inputA?.current?.value != null) {
      setDisableReasonCheck(false);
    }
    else {
      setDisableReasonCheck(true);
    }
  }, [otherReason, inputA])
  const getProfileImage = () => {
    if (data?.SourceTypeId === 1) {
      if (data?.RecipientUser?.Profiles?.PictureUrl?.charAt(0) === "/") {
        return `${process.env.REACT_APP_S3_URL}${data?.RecipientUser?.Profiles?.PictureUrl}`;
      } else {
        return `${process.env.REACT_APP_S3_URL}/${data?.RecipientUser?.Profiles?.PictureUrl}`;
      }
    } else {
      if (data?.SenderUser?.Profiles?.PictureUrl?.charAt(0) === "/") {
        return `${process.env.REACT_APP_S3_URL}${data?.SenderUser?.Profiles?.PictureUrl}`;
      } else {
        return `${process.env.REACT_APP_S3_URL}/${data?.SenderUser?.Profiles?.PictureUrl}`;
      }
    }
  };
  // console.log("favCrd in recievedbidcards", setFavCard);
  // console.log("in rec records", records);
  // console.log("in rec SourceName", SourceName);
  // console.log("in rec SourceId", SourceId);
  // console.log("in rec loading", loading); 
  const handleFavourite = () => {
    // setLoading(!loading);
    setFacClicked(true);
    if (fav == false) { //
      dispatch(
        addMessageToFavourite({
          SourceName,
          SourceId,
          Index,
        })
      );
      setFav(true)
      setfavCard(true)
      // setfavCard(true)
      // setFavCard(true)
    } else {
      dispatch(
        removeMessageFromFavourite({
          SourceId,
          SourceName,
          Index,
        })
      );
      // setfavCard(false)
      setFav(false);
    }
    // setfavCard(!fav)
    setFav(false);
  };

  function rejectModalClose(params) {
    setRejectModalVisible(false);
  }
  const AcceptCandidateBid = () => {
    {
      loading ? <>Loading..</> : <>nothing</>;
    }
    source === 2
      ? dispatch(
        updateProposal({
          id: cardDetails?.ProposalId,
          status: "Accepted",
          loading: "Accept",
        })
      )
      : source === 1
        ? dispatch(
          updateBid({
            id: cardDetails?.BidId,
            BidStatusName: "Accepted",
            SkillListingId: SkillListingCard?.SkillListingId,
            loading: "Accept",
          })
        )
        : console.log("cannot call the api");
  };

  const handleOk = () => {
    dispatch(
      retractBid({
        BidStatusName: "Retracted",
        id: cardDetails?.BidId,
        Message: "Bid was retracted",
        FromMsg: "FromMsg",
        SkillListingId: SkillListingCard.SkillListingId,
      })
    );
    setRetracted(true);
  };

  const disableHandler = () => {
    let array = bidStatus;
    let filteredArray = array.filter(value => value !== null && value !== undefined);
    // let nullCount = array.length - filteredArray.length;
    // console.log(bidStatus.length -props.index-1, bidStatus.length-1, bidStatus ,filteredArray , filteredArray.length,filteredArray.length - props.index,"asfwafafs Index");
    if (status === "Retracted Bid" ||
      bidStatus?.includes("Declined Bid") ||
      bidStatus?.includes("Accepted Bid") ||
      bidStatus?.includes("Retracted Bid") ||
      retracted) {
      return true;
    }
    // console.log(props.index,bidStatus[props.index +1],"asfwafafs Index");
    //prop.index is the inverted index of the current msg and bidStatus.length is the total length of the messages
    else if (filteredArray.length - nonNullIndex == filteredArray.length - 1) {
      return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    if (RetractSuccess) {
      setVisible(false);
      setRetractedBy("Emp");
    }
  }, [RetractSuccess]);

  useEffect(() => {
    if (bidStatus[bidStatus.length - 1] === "New Bid") setDisable(false);
    if (
      bidStatus[bidStatus.length - 2] === "New Bid" &&
      bidStatus[bidStatus.length - 1] != null
    ) {
      setDisable(false);
    }
  }, []);

  const handleCancel = () => {
    setVisible(false);
  };

  //********** convert encrypted html code to HTML tags **********
  var cache = {},
    character,
    e = document.createElement("div");

  const msgtxt = (html) => {
    return html?.replace(/([&][^&; ]+[;])/g, function (entity) {
      character = cache[entity];
      if (!character) {
        e.innerHTML = entity;
        if (e.childNodes[0])
          character = cache[entity] = e.childNodes[0].nodeValue;
        else character = "";
      }
      return character;
    });
  };

  const permanentJob = data?.GigCard?.JobOrderTypes?.JobOrderTypeId === 5;
  const isShift = data?.GigCard?.Shift;

  const chosenContent = SourceName === "Bid" ? (<>
    <Row
      className="flexSpace"
      style={{ width: "100%", justifyContent: "space-between" }}
    >
      <div>Ideal start date</div>
      <div>

        {cardDetails?.IdealStartDate
          ? moment(cardDetails?.IdealStartDate).format("MMMM DD YYYY")
          : moment(bidUpdateSuccess?.IdealStartDate).format(
            "MMMM DD YYYY"
          )}
      </div>
    </Row>
    {permanentJob ? null :
      <Row
        className="flexSpace"
        style={{ width: "100%", justifyContent: "space-between" }}
      >
        <div>Contract length</div>
        <div>
          {permanentJob ? "Permanent" : cardDetails?.IdealTermsId
            ? contractOptions?.find((o) => {
              return (
                o.IdealContractLengthId === cardDetails?.IdealTermsId
              );
            }).IdealContractLengthName
            : cardDetails?.IdealTerm
              ? contractOptions?.find((o) => {
                return o.IdealContractLengthId === cardDetails?.IdealTerm;
              }).IdealContractLengthName
              : null}
        </div>
      </Row>}
  </>) : (
    <>
      {data?.GigCard?.WorkplacePolicy != "fully-remote" &&
        (<Row
          className="flexSpace"
          style={{ width: "100%", justifyContent: "space-between" }}
        >
          <div>Location</div>
          <div>
            {`${data?.GigCard?.Cities?.CityName}, ${data?.GigCard?.Regions?.Code}`}
          </div>
        </Row>)}
      <Row
        className="flexSpace"
        style={{ width: "100%", justifyContent: "space-between" }}
      >
        <div>Tax Term</div>
        <div>
          {`${data?.ProposalCard?.IdealTermsName}`}
        </div>
      </Row>
      {/* <Row
      className="flexSpace"
      style={{ width: "100%", justifyContent: "space-between" }}
    >
      <div>Job Rate</div>
      <div>
        {`$${data?.ProposalCard?.Rate}/wk`}
      </div>
    </Row> */}
    </>);

  const calculateRate = ({ data, cardDetails, bidUpdateSuccess, professionCode }) => {
    return data?.SourceTypeId === 2
      ? cardDetails?.ActualRate
      : data?.SourceTypeId === 1
        ? cardDetails?.Rate?.$numberDecimal ??
        cardDetails?.Rate ??
        bidUpdateSuccess?.Rate?.$numberDecimal ??
        bidUpdateSuccess?.Rate
        : professionCode?.Professions?.ProfessionCode === "IT"
          ? cardDetails?.ActualRate?.$numberDecimal ??
          cardDetails?.ActualRate ??
          cardDetails?.Rate?.$numberDecimal ??
          cardDetails?.Rate
          : cardDetails?.Rate?.$numberDecimal ??
          cardDetails?.Rate ??
          bidUpdateSuccess?.Rate?.$numberDecimal ??
          bidUpdateSuccess?.Rate
  };

  const getBudgetType = (cardDetails, budgetOptions) => {
    if (cardDetails?.BudgetTypeId) {
      const foundOption = budgetOptions?.find((option) => option.BudgetTypeId === cardDetails.BudgetTypeId);
      return foundOption ? foundOption.BudgetType : null;
    }
    return null;
  }
  //*********************************************//
  return (
    <div className="ReceivedBidsCard" key={data?._id}>
      <Modal
        title="Retracting Your Bid?"
        visible={visible}
        onCancel={handleCancel}
        centered
        footer={[
          <>
            <Button onClick={handleCancel} className="modal-no-btn-retract">
              No, go back
            </Button>
            <Button onClick={handleOk} className="modal-ok-btn-retract">
              {RetractLoading ? <LoadingOutlined /> : "Yes, delete it"}
            </Button>
          </>,
        ]}
      >
        <p>Do you want to retract your bid?</p>
      </Modal>
      {editModal && (
        <PlaceBidModal
          visible={placebidModal}
          cardDetails={cardDetails}
          placeBidModalVisisblityHandler={EditBidFunction}
          selectedCandidates={candidateList}
          EditBid={true}
          multiBid={false}
          rate_flag={true}
          Bid_rate={
            cardDetails?.Rate ??
            cardDetails?.Rate?.$numberDecimal ??
            bidUpdateSuccess?.Rate ??
            bidUpdateSuccess?.Rate?.$numberDecimal
          }
          IdealConLength={cardDetails?.IdealTerm ?? bidUpdateSuccess?.IdealTerm}
          SkillListingId={SkillListingCard?.SkillListingId}
          Description={cardDetails?.Comments ?? bidUpdateSuccess?.Comments}
          IdealStartDate={
            cardDetails?.IdealStartDate
              ? moment(cardDetails?.IdealStartDate).format("MMMM DD, YYYY")
              : "N/A"
          }
          BidId={cardDetails?.BidId}
          desired_rate={
            professionCode?.Professions?.ProfessionCode !== "IT" ?
              Math.floor(SkillListingCard?.MinimumBid?.$numberDecimal)
                ? Math.floor(SkillListingCard?.MinimumBid?.$numberDecimal)
                : Math.floor(SkillListingCard?.MinimumBid) :
              SkillListingCard?.ClientRate?.$numberDecimal
                ? parseFloat(SkillListingCard?.ClientRate?.$numberDecimal)
                : SkillListingCard?.ClientRate
          }
          frompdetail={true}
          rateType={cardDetails?.BudgetTypeId ?? bidUpdateSuccess?.BudgetTypeId}
          Title="Edit bid"
          MessageEditsection={true}
          setHidePagePvt={setHidePagePvt}
        />
      )}
      <div
        className={
          status == "Retracted Bid"
            ? // bidStatus?.includes("Accepted Bid") ||
            // bidStatus?.includes("Declined Bid")
            "Retract-bid-cardCont"
            : "cardCont cardCont-prvt-mkt"
        }
      >
        <Row className="card-Header-RB">
          <Row className="flexSpace" style={{ width: "100%", height: "25px", color: status === "Retracted Bid" && "#9e9e9e" }}>
            <div className="inner-heading new-heading" style={{ color: status === "Retracted Bid" && "#9e9e9e" }}>
              {data?.SourceTypeId === 1 ? "You placed a bid on" : "You got a bid from"}
              <div style={{ color: status === "Retracted Bid" && "#9e9e9e" }}>
                <div
                  onClick={(e) => {
                    if (status !== "Retracted Bid") {
                      e.stopPropagation();
                      handleFavourite();
                    }
                  }}
                >
                  {favClicked && inbox?.data?.data?.body?.conversations[favouriteRed?.Index]?._id == records?._id && loading ?
                    <LoadingOutlined /> :
                    (fav === false) ? (
                      <StarOutlined style={{ fontSize: "17px", color: "#aaaaaa" }} />
                    ) : (
                      <StarFilled style={{ fontSize: "17px", color: "#ffba08" }} />
                    )
                  }
                </div>
              </div>
            </div>
          </Row>
          <Row style={{ width: "100%", color: status === "Retracted Bid" && "#9e9e9e" }}>
            <div
              style={{ color: status === "Retracted Bid" && "#9e9e9e" }}
              className={
                status?.includes("Accepted Bid") ||
                  status?.includes("Declined Bid")
                  ? "disable-container"
                  : "candidate-card-image"
              }
            >
              {
                (data?.SourceTypeId === 1
                  ? (data?.RecipientUser?.Profiles?.PictureUrl && data?.RecipientUser?.Profiles?.PictureUrl?.split("/")?.pop() !== "no-pic.png")
                  : (data?.SenderUser?.Profiles?.PictureUrl && data?.SenderUser?.Profiles?.PictureUrl?.split("/")?.pop() !== "no-pic.png")) &&
                  !imageError ? (
                  <img
                    onError={() => setImageError(true)}
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "50%",
                      opacity: status === "Retracted Bid" && "60%",
                    }}
                    src={getProfileImage()}
                    alt="title"
                  />
                ) : (
                  <div className="image-container"
                    style={{ color: status === "Retracted Bid" && "#9e9e9e" }}
                    onClick={() => {
                      history.push({
                        pathname: "/resume-3d",
                        state: {
                          candidateid:
                            data && data?.SourceTypeId === 1
                              ? data?.RecipientUser?.AccountId
                              : data?.SenderUser?.AccountId,
                          fromSpecificRedirect: true
                        },
                      });
                    }}>
                    <div className="image-text">
                      {data?.SourceTypeId === 1
                        ? data?.RecipientUser?.Profiles?.FirstName
                          ? data?.RecipientUser?.Profiles?.FirstName?.split(
                            ""
                          )[0].toUpperCase()
                          : data?.RecipientUser?.UserName?.split(
                            ""
                          )[0].toUpperCase()
                        : data?.SenderUser?.Profiles?.FirstName
                          ? data?.SenderUser?.Profiles?.FirstName?.split(
                            ""
                          )[0].toUpperCase()
                          : data?.SenderUser?.UserName?.split("")[0].toUpperCase()}
                    </div>
                  </div>
                )}
            </div>
            <div className={status === "Retracted Bid" ? "Retracted_Bid_mkt" : null} >
              <div style={{
                width: "100%",
                alignItems: "flex-end",
                justifyContent: "start",
                cursor: "pointer", display: "flex", flexDirection: "row",
                color: status === "Retracted Bid" && "#9e9e9e"
              }}
                className={
                  status === "Retracted Bid"
                    ? "Retratced-textBold"
                    : "textBold textBold2"
                }
              >
                <div
                  className={status === "Retracted Bid" ? null : "user-name-add-section"}
                  onClick={() => {
                    history.push({
                      pathname: "/resume-3d",
                      state: {
                        candidateid:
                          data && data?.SourceTypeId === 1
                            ? data?.RecipientUser?.AccountId
                            : data?.SenderUser?.AccountId,
                        fromSpecificRedirect: true,
                      },
                    });
                  }}

                >
                  {data?.SourceTypeId === 1 ? data?.RecipientUser?.Profiles?.FirstName + data?.RecipientUser?.Profiles?.LastName :
                    data?.SenderUser?.Profiles?.FirstName + data?.SenderUser?.Profiles?.LastName}

                  {" "}
                  <span style={{ marginLeft: '5px', cursor: "pointer" }}

                  >
                    <img src={StarIcon} alt="star-icon" />
                    <span className="star-value" style={{ marginLeft: '3px', marginRight: '3px' }}
                    >
                      {data?.SourceTypeId == 1
                        ? data?.RecipientUser?.Profiles?.Rating
                          ? " " +
                          data?.RecipientUser?.Profiles?.Rating
                          : " " + DefaultRating
                        : data?.SenderUser?.Profiles?.Rating
                          ? data?.SenderUser?.Profiles?.Rating
                          : " " + DefaultRating}
                    </span>
                    <span className="privatetms" style={{ color: status === "Retracted Bid" && "#9e9e9e" }}>
                      ({privateids?.reduce((acc, val) => (val === data?.RecipientUser?.AccountId ? acc + 1 : acc), 0)})
                    </span>
                  </span>
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  marginTop: "5px",
                  color: status === "Retracted Bid" && "#9e9e9e",
                }}
              >
                <img
                  src={suitCaseIcon}
                  alt="suitcase"
                  style={{ width: "13px", height: "13px", marginRight: "5px" }}
                />
                <div className="privatetms" style={{ color: status === "Retracted Bid" && "#9e9e9e" }}>
                  {data?.SourceTypeId === 1
                    ? data?.RecipientUser?.Profiles?.ExperienceLevels
                      ?.ExperienceLevelName
                      ? data?.RecipientUser?.Profiles?.ExperienceLevels
                        ?.ExperienceLevelName
                      : "N/A"
                    : data?.SenderUser?.Profiles?.ExperienceLevels
                      ?.ExperienceLevelName
                      ? data?.SenderUser?.Profiles?.ExperienceLevels
                        ?.ExperienceLevelName
                      : "N/A"}
                  {/* {data?.RecipientUser?.Profiles?.ExperienceLevels
                  ?.ExperienceLevelName ?? "N/A"} */}
                </div>
              </div>
            </div>
          </Row>

          <Row style={{ width: "100%", color: status === "Retracted Bid" && "#9e9e9e" }}>
            <span className="skill-listing-txt" style={{ color: status === "Retracted Bid" && "#9e9e9e" }}>
              {data?.SourceTypeId === 1 ? "For skill listing:" : "Tax Term:"}
              {data?.SourceTypeId === 1
                ? " " + SkillListingCard?.Title
                : " " + data?.ProposalCard?.IdealTermsName}
            </span>
          </Row>

          <Row
            className="card-Body-RB textRegular message-PB-pvt-2"
            style={{ color: status === "Retracted Bid" && "#9e9e9e", width: "100%", paddingLeft: "0px" }}
          >
            <div
              className="bidRateBold Mesage-place-bid-bold"
              style={{ color: status === "Retracted Bid" && "#9e9e9e" }}
            >
              {"$"}
              {calculateRate({ data, cardDetails, bidUpdateSuccess, professionCode })?.toFixed(2)}
              {"/"}
              {getBudgetType(cardDetails, budgetOptions) === "hr" ? "Hour" : getBudgetType(cardDetails, budgetOptions)}
              {(getBudgetType(cardDetails, budgetOptions) === "hr" || getBudgetType(cardDetails, budgetOptions) === "wk") &&
                (!permanentJob) && (
                  status !== "Retracted Bid" ? (
                    <img
                      src={isHovered ? InfoIcon : InfoIconLight}
                      alt="info-icon"
                      onClick={handleInfoIconClick}
                      onMouseOver={handleInfoIconHover}
                      onMouseLeave={handleInfoIconMouseLeave}
                      data-tooltip-id="info-icon-tooltip"
                      style={{ marginLeft: '5px', cursor: 'pointer' }}
                      data-tip
                      data-event="click"
                      data-for='test'
                    />
                  ) : (
                    <img
                      src={InfoIconLight}
                      alt="info-icon"
                      style={{ marginLeft: '5px' }}
                    />
                  )
                )}
            </div>
            <Tooltip
              id="info-icon-tooltip"
              isOpen={isTooltipVisible}
              style={{ zIndex: '1', borderRadius: ".375rem" }}
              ref={tooltipRef}
              clickable={true}
              globalEventOff="click"
            >
              <PayCalculation
                amount={calculateRate({
                  data,
                  cardDetails,
                  bidUpdateSuccess,
                  professionCode,
                })}
                isPrivateGig={userProfile?.EmployeeAssociation?.includes(data?.RecipientUser?.AccountId)}
                onClose={handleTooltipClose}
                ProfessionCode={professionCode?.Professions?.ProfessionCode}
                taxTerm={data?.ProposalCard?.IdealTermsName ?? data?.BidCard?.IdealTermsName}
                SourceId={data?.SourceTypeId}
              />
            </Tooltip>
            {/* {chosenContent} */}

          </Row>
          <Row className="card-Body-RB message-PB-pvt" style={{ paddingLeft: "0px", color: status === "Retracted Bid" && "#9e9e9e" }}>
            <span style={{ color: status === "Retracted Bid" && "#9e9e9e" }}>
              {data?.SenderUser?.Profiles?.CompanyName} is seeking a
              <a className="anchor" style={{ color: status === "Retracted Bid" && "#9e9e9e" }}
                onClick={() => {
                  if (status !== "Retracted Bid") {
                    data?.SourceTypeId === 1 &&
                      history.push({
                        pathname: `/jobdetail/${jobDetails?.JobOrderId}`,
                        state: {
                          fromSpecificRedirect: true,
                        },
                      });
                  }
                }}>
                {jobDetails?.Title} <img src={RedirectIcon} alt="redirect-icon" style={{ color: status === "Retracted Bid" && "#9e9e9e" }} />
              </a>
              
             for a {jobDetails?.JobOrderTypes?.JobOrderTypeName} job
{jobDetails?.Regions?.RegionName || jobDetails?.Countries?.CountryName
  ? ` in ${jobDetails?.Regions?.RegionName ?? jobDetails?.Countries?.CountryName}${jobDetails?.CityName ? `, ${jobDetails?.CityName}` : ''}${jobDetails?.Cities?.CityName && jobDetails?.CityName !== jobDetails?.Cities?.CityName ? ` ${jobDetails?.Cities?.CityName}` : ''}${jobDetails?.Cities?.CityCode ? `, ${jobDetails?.Cities?.CityCode}` : ''}`
  : ""}


            </span>
          </Row>
          <Row className="card-Body-RB card-Body-RB-placeBid" style={{ paddingLeft: "0px", color: status === "Retracted Bid" && "#9e9e9e" }}>
            <div className="exp-wrapper-div" style={{ color: status === "Retracted Bid" && "#9e9e9e" }}>
            {data?.SenderUser?.Profiles?.Speciality?.length > 0 && (
  <div>
    <img src={Speciality} alt="Speciality-icon" className="icon-style" />
    Speciality: {data.SenderUser.Profiles.Speciality.join(", ")}
  </div>
)}



{data?.SenderUser?.Profiles?.Discipline && (
  <div>
    <img src={Discipline} alt="Discipline-icon" className="icon-style" />
    Discipline:{" "} {data.SenderUser.Profiles.Discipline}
  </div>
)}

              <div>
                <img src={ExperienceIcon} alt="experience-icon" className="icon-style" />
                Experience: {" "}
                {data?.SourceTypeId === 1
                  ? data?.RecipientUser?.Profiles?.ExperienceLevels
                    ?.ExperienceLevelName
                    ? data?.RecipientUser?.Profiles?.ExperienceLevels
                      ?.ExperienceLevelName
                    : "N/A"
                  : data?.SenderUser?.Profiles?.ExperienceLevels
                    ?.ExperienceLevelName
                    ? data?.SenderUser?.Profiles?.ExperienceLevels
                      ?.ExperienceLevelName
                    : "N/A"}
              </div>
              <div >
                {isShift ? (
                  <>
                    <img src={shift} alt="shift-icon" className="icon-style" />
                      Shift: {isShift} </>
                ) : null}

              </div>

              {data?.BidCard?.IdealStartDate && (
  <div>
    <img src={CalenderIcon} alt="calendar-icon" className="icon-style" />
    Start date:{" "}
    {moment(data.BidCard.IdealStartDate).format("dddd, MMMM DD, YYYY")}
  </div>
)}
              {jobordertype === "Contract" && data?.BidCard?.IdealTerm && (
                <div>
                  <img src={DurationIcon} alt="duration-icon" className="icon-style" />
                  Duration: {contractOptions.find((el)=> el.IdealContractLengthId == data?.BidCard?.IdealTerm)?.IdealContractLengthName}
                </div>
              )}
              {/* <div>
            <img src={AuthorizationIcon} alt="authorization-icon" style={{paddingRight:'5px'}}/>
            Work authorization:{" "}  {data?.GigCard?.WorkAuthorization ?? "N/A"}
          </div> */}

              {/* <div style={{paddingLeft: ".25rem"}}>
            <img src={WorkPlaceIcon} alt="workplace-icon" className="icon-style"/>
            Workplace policy: {" "} {data?.GigCard?.WorkplacePolicy ?? "N/A"}
          </div> */}
            </div>
          </Row>
        </Row>
        {/* <Row
          className="card-Body-RB textRegular"
          style={{ color: status === "Retracted Bid" && "#9e9e9e" }}
        >
          <div
            className="bidRateBold"
            style={{ color: status === "Retracted Bid" && "#9e9e9e" }}
          >
            Bid Rate {"$"}
            {calculateRate({ data, cardDetails, bidUpdateSuccess, professionCode })}
            {" / "}
            {getBudgetType(cardDetails, budgetOptions)}
            {(getBudgetType(cardDetails, budgetOptions) === "hr" || getBudgetType(cardDetails, budgetOptions) === "wk") &&
              professionCode?.Professions?.ProfessionCode === "IT" && (
              status !== "Retracted Bid" ? (
                <img
                  src={isHovered ? InfoIcon : InfoIconLight}
                  alt="info-icon"
                  onClick={handleInfoIconClick}
                  onMouseOver={handleInfoIconHover}
                  onMouseLeave={handleInfoIconMouseLeave}
                  data-tooltip-id="info-icon-tooltip"
                  style={{ marginLeft: '5px' }}
                  data-tip
                  data-event="click"
                  data-for='test'
                />
              ) : (
                <img
                  src={InfoIconLight}
                  alt="info-icon"
                  style={{ marginLeft: '5px' }}
                />
              )
            )}
          </div>
          <Tooltip
            id="info-icon-tooltip"
            // place="bottom"
            isOpen={isTooltipVisible}
            style={{ zIndex: '1' }}
            ref={tooltipRef}
            clickable={true}
            globalEventOff="click"
          >
            <PayCalculation
              amount={calculateRate({
                data,
                cardDetails,
                bidUpdateSuccess,
                professionCode,
              })}
              isPrivateGig={true}
              onClose={handleTooltipClose}
            />
          </Tooltip>
          {chosenContent}

        </Row> */}
        <div style={{ padding: ".625rem 15px 10px 15px" }}>
          <div className={status === "Retracted Bid" ? null : "Recruiter-msg-title"} >{SourceName === "Proposal" ? "Cover Letter" : "Message"}</div>
          <div
            className="textRegular textR"
            style={{ color: status === "Retracted Bid" && "#9e9e9e" }}
          // dangerouslySetInnerHTML={
          //   bidUpdateSuccess?.Comments
          //     ? { __html: msgtxt(cardDetails?.Comments) }
          //     : {
          //       __html: cardDetails?.Comments
          //         ? msgtxt(cardDetails?.Comments)
          //         : msgtxt(cardDetails?.Message),
          //     }
          // }
          >
            <HyperlinkParagraph
              text={
                bidUpdateSuccess?.Comments
                  ? cardDetails?.Comments
                  : cardDetails?.Comments
                    ? cardDetails?.Comments
                    : cardDetails?.Message
              }
            />
          </div>
          <div
            className="time-chat"
            style={{ color: status == "Retracted Bid" && "#9e9e9e" }}
          >
            {moment(Created).format("h:m a")}{" "}
            {/* <RiCheckDoubleLine className="double-check-icon" /> */}
            {userProfile?._id === data?.SenderUser?._id ? (
              <RiCheckDoubleLine className="double-check-icon" />
            ) : null}
          </div>
        </div>
      </div>

      {source === 2 ? (
        <Row className="buttonsCont buttonsCont-row-reverse">
          <Button
            className={
              status === "Retracted Bid" ||
                bidStatus?.includes("Declined Bid") ||
                bidStatus?.includes("Accepted Bid") ||
                bidStatus?.includes("Retracted Bid")
                ? "Retracted-btn"
                : "btncard btncard-pvt-tag2"
            } //
            onClick={AcceptCandidateBid}
            disabled={
              // status == "Retracted Bid" ||
              // bidStatus?.includes("Declined Bid") ||
              // bidStatus?.includes("Accepted Bid") ||
              // bidStatus?.includes("Retracted Bid")
              disableHandler()
            }
          >
            {proposalLoading === "Accept" ? (
              <LoadingOutlined />
            ) : bidStatus.includes("Accepted Bid") ? (
              <span>
                {"Accept" + " "}
                <span className="text-update-interview">(for interview)</span>
              </span>
            ) : (
              <span>
                {"Accept" + " "}
                <span className="text-update-interview">(for interview)</span>
              </span>
            )}
          </Button>
          <Button
            className={
              status === "Retracted Bid" ||
                status === "Declined Bid" ||
                bidStatus?.includes("Declined Bid") ||
                bidStatus?.includes("Accepted Bid") ||
                bidStatus?.includes("Retracted Bid")
                ? "Retracted-btn"
                : "btncard btncard-pvt-tag"
            } //
            onClick={() => setRejectModalVisible(true)}
            disabled={
              // status === "Retracted Bid" ||
              // bidStatus?.includes("Declined Bid") ||
              // bidStatus?.includes("Accepted Bid") ||
              // bidStatus?.includes("Retracted Bid")
              disableHandler()
            }
          >
            {proposalLoading === "Declined" ? (
              <LoadingOutlined />
            ) : bidStatus.includes("Declined Bid") ? (
              "Decline"
            ) : (
              "Decline"
            )}
          </Button>
        </Row>
      ) : (
        source === 1 && (
          <Row className="buttonsCont">
            <Button
              className={
                status === "Retracted Bid" ||
                  bidStatus?.includes("Declined Bid") ||
                  bidStatus?.includes("Accepted Bid") ||
                  bidStatus?.includes("Retracted Bid")
                  ? "Retracted-btn"
                  : "btncard btncard-pvt-tag"
              }
              disabled={
                // status === "Retracted Bid" ||
                // bidStatus?.includes("Declined Bid") ||
                // bidStatus?.includes("Accepted Bid") ||
                // bidStatus?.includes("Retracted Bid") ||
                // retracted
                disableHandler()
              }
              onClick={() => setVisible(true)}
            >
              {status === "Retracted Bid" ? "Bid retracted" : "Retract Bid"}
            </Button>
            <Button
              className={
                status === "Retracted Bid" ||
                  bidStatus?.includes("Declined Bid") ||
                  bidStatus?.includes("Accepted Bid")
                  ? "Retracted-btn"
                  : "btncard btncard-pvt-tag"
              }
              disabled={
                // status === "Retracted Bid" ||
                // bidStatus?.includes("Declined Bid") ||
                // bidStatus?.includes("Accepted Bid") ||
                // bidStatus?.includes("Retracted Bid") ||
                // retracted
                disableHandler()
              }
              onClick={() => EditBidFunction(true)}
            >
              Edit bid
            </Button>
          </Row>
        )
      )}

      <Modal
        title="Decline bid?"
        onCancel={rejectModalClose}
        visible={rejectModalVisible}
        footer={null}
      >
        <div style={{ color: disableReasonCheck && submitReasonClicked ? '#DB2828' : '#3E3E3E' }}>Please select a reason for declining this bid:</div>
        <div
          ref={inputA}
          className="reject-modal-div"
          data-id="Accepted another candidate"
          onClick={(e) => {
            inputA.current.value = 1;
            setDeclineReason('Accepted another candidate');
            setDisableReasonCheck(false);
            inputA.current.style.backgroundColor = "#e4ffec";
            inputN.current.style.backgroundColor = "white";
            inputAs.current.style.backgroundColor = "white";
            setRejectReason(e.target.getAttribute("data-id"));
            setOtherReason('');
            setSubmitReasonClicked(false)
          }}
        >
          Accepted another candidate
        </div>
        <div
          ref={inputN}
          className="reject-modal-div"
          data-id="Skills not a match"
          onClick={(e) => {
            inputA.current.value = 2;
            setDeclineReason('Skills not a match');
            setDisableReasonCheck(false);
            inputA.current.style.backgroundColor = "white";
            inputN.current.style.backgroundColor = "#e4ffec";
            inputAs.current.style.backgroundColor = "white";
            setRejectReason(e.target.getAttribute("data-id"));
            setOtherReason('');
            setSubmitReasonClicked(false);
          }}
        >
          Skills not a match
        </div>
        <div
          ref={inputAs}
          className="reject-modal-div"
          data-id="Asking Payrate is too high"
          onClick={(e) => {
            inputA.current.value = 4;
            setDeclineReason('Asking Payrate is too high');
            setDisableReasonCheck(false);
            inputA.current.style.backgroundColor = "white";
            inputN.current.style.backgroundColor = "white";
            inputAs.current.style.backgroundColor = "#e4ffec";
            setRejectReason(e.target.getAttribute("data-id"));
            setOtherReason('');
            setSubmitReasonClicked(false);
          }}
        >
          Asking payrate is too high
        </div>
        <div
          className="other-div"
        // onClick={(e) => {
        //   inputA.current.value = 4;
        //   setDisabled(true);
        //   inputA.current.style.backgroundColor = "white";
        //   inputN.current.style.backgroundColor = "white";
        //   inputAs.current.style.backgroundColor = "#e4ffec";
        //   // setRejectReason(e.target.getAttribute("data-id"));
        // }}
        >
          <h4>Other</h4>
          <div
            // ref={inputAs}
            // className="reject-modal-div"
            data-id="other"
          >
            <TextArea
              showCount
              maxLength={50}
              className="otherReasonInput"
              style={{
                height: 80,
                resize: 'none',
                border: 'solid 1px #d4d4d4',
                borderRadius: '4px',
              }}
              onChange={(e) => setOtherReason(e?.target?.value)}
              placeholder="Please mention the reason"
              value={otherReason}
            />
          </div>
        </div>
        <button
          className={"rejectModalBtn"}
          // className={
          //   inputA?.current?.value || otherReason?.length>0
          //     ? "rejectModalBtn"
          //     : "rejectModalBtn_disabled"
          // }
          // className={inputA?.current?.value == null ? "rejectModalBtnDisabled" : "rejectModalBtn"}
          // disabled={inputA?.current?.value == null && otherReason?.length<1}
          // disabled={disableReasonCheck}
          onClick={() => {
            if (otherReason?.length < 1 && declineReason?.length < 1) {
              setSubmitReasonClicked(true);
              return;
            }
            else if (otherReason?.length > 0) {
              setRejectModalVisible(false);
              dispatch(
                updateProposal({
                  id: data?.ProposalCard?.ProposalId ?? data?.BidCard?.BidId,
                  status: "Declined",
                  DeclineReasonId: 10,
                  DeclineReason: otherReason,
                  loading: "Declined",
                })
              );
            }
            else {
              setRejectModalVisible(false);
              dispatch(
                updateProposal({
                  id: data?.ProposalCard?.ProposalId ?? data?.BidCard?.BidId,
                  status: "Declined",
                  DeclineReasonId: 10,
                  DeclineReason: declineReason,
                  loading: "Declined",
                })
              );
            }
            // else if (inputA?.current?.value != null) {
            //   setRejectModalVisible(false);
            //   dispatch(
            //     updateProposal({
            //       id: data?.ProposalCard?.ProposalId ?? data?.BidCard?.BidId,
            //       status: "Declined",
            //       DeclineReasonId: inputA.current.value,
            //       loading: "Declined",
            //     })
            //   );
            // }
          }}
        >
          Submit Reason
        </button>
      </Modal>
    </div>
  );
}

